import * as types from '../types';

// {
//    paywayId: {pmId, currency, details}, ...
// }
const INITIAL_STATE = {};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.PAY_METHODS_FETCHED: {
      const payMethods = action.payload;

      const payWays = payMethods.reduce(
        (
          previous,
          { id: pmId, pwCcyAlias: currency, pwAlias: defaultPayWay }
        ) => {
          previous[defaultPayWay] = {
            details: null,
            selected: false,
            ...(state[defaultPayWay] || {}),
            currency,
            pmId,
          };

          return previous;
        },
        {}
      );

      return {
        ...state,
        ...payWays,
      };
    }
    case types.PAY_WAY_FETCHED: {
      const {
        id,
        data: {
          pmId,
          pwCcyAlias: currency,
          addOns,
          payerPrice,
          payerFee,
          exchFee,
          info: description,
          manual,
          warning,
        },
      } = action.payload;

      return {
        ...state,
        [id]: {
          selected: false,
          ...(state[id] || {}),
          pmId,
          currency,
          details: {
            addOns,
            payerPrice,
            payerFee,
            description,
            manual,
            warning,
            exchFee,
          },
        },
      };
    }
    case types.PAY_WAYS_FOR_PAY_METHOD_FETCHED: {
      const { id: pmId, data } = action.payload;

      const payWays = data.reduce(
        (previous, { alias: id, ccyAlias: currency }) => {
          previous[id] = {
            selected: false,
            details: null,
            ...(state[id] || {}),
            pmId,
            currency,
          };

          return previous;
        },
        {}
      );

      return {
        ...state,
        ...payWays,
      };
    }
    case types.SELECT_PAY_WAY: {
      const id = action.payload;

      if (typeof state[id] == 'undefined') return state;

      return Object.keys(state).reduce((previous, pwId) => {
        const pw = state[pwId];

        previous[pwId] = {
          ...pw,
          selected: pwId === id,
        };

        return previous;
      }, {});
    }
    default:
      return state;
  }
}
